/**
 * Task equipment links grouped by room, rooms in the order they first appear
 * and links in list order within each room. Shared by the Opgaveudstyr card
 * and the completion warning so both list equipment the same way.
 * Returns [{ roomId, roomName, items }].
 */
export function groupEquipmentByRoom(links, noRoomLabel) {
  const groups = new Map();
  links.forEach((item) => {
    const roomId = item.equipment?.room_id || 'no_room';
    if (!groups.has(roomId)) {
      groups.set(roomId, { roomId, roomName: item.equipment?.room?.name || noRoomLabel, items: [] });
    }
    groups.get(roomId).items.push(item);
  });
  return [...groups.values()];
}
